import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Projectdetails = () => {
  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main className="overflow-hidden">

      <section className="ul-breadcrumb ul-section-spacing">
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title" id="breadcrumb-title">
            Campaign Details
          </h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li><Link to="/projects">Campaigns</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li id="breadcrumb-campaign">Campaign Details</li>
          </ul>
        </div>
      </section>

      <div className="ul-container ul-section-spacing">

        <div
          className="ul-project-details-img-slider swiper"
          style={{
            borderRadius: 'clamp(15px, 1.05vw, 20px)',
            overflow: 'hidden',
            marginBottom: 'clamp(30px, 3.15vw, 50px)'
          }}
        >
          <div className="swiper-wrapper" id="image-slider-wrapper">

          </div>

          <div className="ul-project-details-slider-nav ul-slider-nav">
            <button className="prev"><i className="flaticon-back"></i></button>
            <button className="next"><i className="flaticon-next"></i></button>
          </div>
        </div>

        <div className="row gx-5 gy-4 flex-column-reverse flex-lg-row">

          <div className="col-md-8">
            <div className="ul-event-details">
              <h2
                className="ul-event-details-title"
                id="campaign-title"
                style={{
                  color: 'var(--ul-primary)',
                  marginBottom: 'clamp(20px, 2.1vw, 30px)'
                }}
              >
                Asthma Management for NYC Families
              </h2>

              <p
                className="ul-event-details-descr"
                id="campaign-intro"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(20px, 2.1vw, 30px)'
                }}
              >
                Central Asian community-focused asthma education and clinic
                connections.
              </p>

              <p
                className="ul-event-details-descr"
                id="campaign-description"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(30px, 3.15vw, 40px)'
                }}
              >
                Our Asthma Management campaign addresses the critical need for
                culturally-relevant asthma education in Central Asian
                communities across New York City. Through bilingual content,
                visual guides, and direct clinic connections, we're helping
                families better understand and manage asthma.
              </p>

              <h3
                className="ul-event-details-inner-title"
                style={{
                  color: 'var(--ul-primary)',
                  marginBottom: 'clamp(15px, 1.58vw, 25px)',
                  fontSize: 'clamp(22px, 1.68vw, 28px)'
                }}
              >
                Challenge & Solution
              </h3>
              <p
                className="ul-event-details-descr"
                id="challenge-solution"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(30px, 3.15vw, 40px)'
                }}
              >
                Asthma disproportionately affects underserved communities, and
                language barriers often prevent families from accessing proper
                care and education. Our campaign bridges this gap by providing
                clear, actionable information in Uzbek, Russian, and English,
                while connecting families directly to verified clinics that
                offer culturally-competent care.
              </p>

              <h3
                className="ul-event-inner-title"
                style={{
                  color: 'var(--ul-primary)',
                  marginBottom: 'clamp(15px, 1.58vw, 25px)',
                  fontSize: 'clamp(22px, 1.68vw, 28px)'
                }}
              >
                Impact & Results
              </h3>
              <p
                className="ul-event-details-descr"
                id="impact-results"
                style={{
                  fontSize: 'clamp(15px, 1.05vw, 18px)',
                  lineHeight: 1.8,
                  marginBottom: 'clamp(20px, 2.1vw, 30px)'
                }}
              >
                Through our comprehensive approach combining education, resource
                connection, and community engagement, we've successfully reached
                hundreds of families with vital asthma management information.
              </p>

              <div
                className="ul-service-details-inner-block"
                style={{
                  background: 'var(--ul-c3)',
                  padding: 'clamp(25px, 2.63vw, 40px)',
                  borderRadius: 'clamp(10px, 0.84vw, 15px)',
                  marginBottom: 'clamp(30px, 3.15vw, 40px)'
                }}
              >
                <h4
                  style={{
                    color: 'var(--ul-primary)',
                    marginBottom: 'clamp(15px, 1.58vw, 25px)',
                    fontSize: 'clamp(20px, 1.47vw, 24px)'
                  }}
                >
                  Key Achievements
                </h4>
                <ul
                  id="achievements-list"
                  style={{listStyle: 'none', padding: 0, margin: 0}}
                >

                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div
              className="ul-project-details-infos"
              style={{
                background: 'var(--ul-c3)',
                padding: 'clamp(25px, 2.63vw, 35px)',
                borderRadius: 'clamp(10px, 0.84vw, 15px)'
              }}
            >
              <h4
                className="ul-project-details-infos-title"
                style={{
                  color: 'var(--ul-primary)',
                  marginBottom: 'clamp(20px, 2.1vw, 30px)'
                }}
              >
                Campaign Information
              </h4>
              <ul className="ul-project-details-infos-list" id="campaign-info-list">

              </ul>

              <div
                className="ul-footer-socials ul-project-details-infos-shares"
                style={{
                  marginTop: 'clamp(25px, 2.63vw, 35px)',
                  paddingTop: 'clamp(25px, 2.63vw, 35px)',
                  borderTop: '1px solid rgba(43, 122, 143, 0.2)'
                }}
              >
                <span
                  style={{
                    display: 'block',
                    marginBottom: 'clamp(10px, 1.05vw, 15px)',
                    color: 'var(--ul-black)',
                    fontWeight: 600
                  }}
                  >Share this campaign:</span
                >
                <a href="https://facebook.com/pathio" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="flaticon-facebook"></i></a>
                <a href="https://twitter.com/pathio" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="flaticon-twitter"></i></a>
                <a href="https://linkedin.com/company/pathio" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><i className="flaticon-youtube"></i></a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="ul-service-details-inner-block"
          style={{
            background: 'linear-gradient(135deg, var(--ul-primary) 0%, var(--ul-secondary) 100%)',
            padding: 'clamp(30px, 3.15vw, 50px)',
            borderRadius: 'clamp(10px, 0.84vw, 15px)',
            color: 'var(--white)',
            marginTop: 'clamp(40px, 4.21vw, 60px)',
            textAlign: 'center'
          }}
        >
          <h3
            className="ul-service-details-inner-title"
            style={{
              color: 'var(--white)',
              marginBottom: 'clamp(15px, 1.58vw, 25px)',
              fontSize: 'clamp(22px, 1.68vw, 28px)'
            }}
          >
            Get Involved
          </h3>
          <p
            className="ul-service-details-descr"
            id="cta-description"
            style={{
              color: 'rgba(255, 255, 255, 0.95)',
              fontSize: 'clamp(15px, 1.05vw, 18px)',
              lineHeight: 1.8,
              marginBottom: 'clamp(20px, 2.1vw, 30px)',
              maxWidth: '700px',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            Want to support this campaign or learn more about how you can help?
            Contact us to get involved.
          </p>
          <Link to="/contact"
            className="ul-btn"
            style={{background: 'var(--white)', color: 'var(--ul-primary)'}}
          >
            <i className="flaticon-fast-forward-double-right-arrows-symbol"></i>
            Contact Us
          </Link>
        </div>

        <div
          className="ul-project-details-nav"
          style={{
            marginTop: 'clamp(40px, 4.21vw, 60px)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 'clamp(15px, 1.58vw, 30px)'
          }}
        >
          <Link to="/projects"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(8px, 0.84vw, 12px)',
              color: 'var(--ul-black)',
              fontWeight: 600,
              transition: '0.3s ease'
            }}
            ><i className="flaticon-back"></i> <span>Back to Campaigns</span></Link
          >
          <Link to="/contact"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(8px, 0.84vw, 12px)',
              color: 'var(--ul-primary)',
              fontWeight: 600,
              transition: '0.3s ease'
            }}
            ><span>Get Involved</span> <i className="flaticon-next"></i
          ></Link>
        </div>
      </div>
    </main>

      <Footer />
    </>
  );
};

export default Projectdetails;
